import { makeObservable } from 'mobx';
import { ClientConfigurationModel, HospitalOrganizationListingModel, IHospitalOrganizationListingModel, IOrderByParams } from '@common/models';
import { StandardSearchStore } from '@common/stores';
import { SearchService } from '@common/services/searchService';

const defaultHospitalSortOrder: Array<IOrderByParams> = [
    {
        field: "ot.ParentOrganizationId",
        dir: "asc"
    },
    {
        field: "ot.Name",
        dir: "asc"
    }
]
export interface IHospitalOrganizationsSearchFilter {
    searchterm?: string,
    uid?: number,
    dropCorpId?: number,
    unrelated: 0 | 1 | undefined;
}

const defaultHospitalSearchFilter: IHospitalOrganizationsSearchFilter = {
    searchterm: undefined,
    dropCorpId: undefined,
    unrelated: undefined
}
export class HospitalOrganizationsSearchStore extends StandardSearchStore<IHospitalOrganizationsSearchFilter, IHospitalOrganizationListingModel, HospitalOrganizationListingModel> {

    constructor(configuration: ClientConfigurationModel, defaultSearchFilterOverrides?: Partial<IHospitalOrganizationsSearchFilter>) {
        super({
            endpointUrl: SearchService.SearchEndPoints.hospitalOrganizations,
            defaultSearchParams: {
                orderby: defaultHospitalSortOrder, top: 10
            },
            defaultSearchFilter: {
                ...defaultHospitalSearchFilter,
                dropCorpId: configuration.currentCorpOrganization.organizationId,
                ...defaultSearchFilterOverrides
            },
        }, (result: IHospitalOrganizationListingModel) => new HospitalOrganizationListingModel(result));
        makeObservable(this, undefined);
    }
}
